module.exports = __webpack_public_path__ + "static/img/soogif.1de123d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/soogif.gif
// module id = LUxm
// module chunks = 78